export default __webpack_public_path__ + "static/media/lock-icon.06952fd9.svg";